import * as actions from './actions';

const dashboardModule = {
  namespaced: true,
  actions,
};

export default dashboardModule;
